// extracted by mini-css-extract-plugin
export default {"bannerStyle":"PocetnaBaner_bannerStyle__HWsGI","videoStyle":"PocetnaBaner_videoStyle__8JIBX"};